import { Badge } from '@/components/ui/badge'
import { Text } from '@/components/ui/text'
import { Show, createMemo } from 'solid-js'
import { useService } from 'solid-services'
import { Flex } from 'styled-system/jsx'
import { usePresence } from '../state/usePresence'

export default function TypingIndicator() {
  const { typingUsers } = useService(usePresence)()

  const typingText = createMemo(() => {
    const users = typingUsers()
    const count = users.length

    if (count === 0) return ''
    if (count === 1) return `${users[0]} is typing...`
    if (count === 2) return `${users[0]} and ${users[1]} are typing...`
    if (count === 3) return `${users[0]}, ${users[1]} and ${users[2]} are typing...`

    return 'Many users are typing...'
  })

  return (
    <Show when={typingUsers().length > 0}>
      <Flex
        position="absolute"
        justifyContent="center"
        bottom={1}
        px={3}
        py={3}
        width="100%"
        zIndex={1}
      >
        <Badge
          textStyle="xs"
          colorPalette="jade"
          variant='subtle'
          fontStyle="italic"
          animation="pulse  1.5s infinite ease-in-out"
        >
          {typingText()}
        </Badge>
      </Flex>
    </Show>
  )
}
